import { Box, Button, Container, Typography } from '@mui/material';
import { BlockOutlined, HomeOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

/**
 * Access Denied page - displayed when user tries to access a page they don't have permission for
 */
const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '70vh',
          textAlign: 'center',
          gap: 3,
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            width: 120,
            height: 120,
            borderRadius: '50%',
            bgcolor: 'error.light',
            color: 'error.contrastText',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 3,
            mb: 2,
          }}
        >
          <BlockOutlined sx={{ fontSize: 64 }} />
        </Box>

        {/* Main Message */}
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          Access Denied
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600 }}>
          You don't have permission to access this page. Please contact your administrator if you believe this is an
          error.
        </Typography>

        {/* Additional Info */}
        <Box
          sx={{
            bgcolor: 'background.paper',
            p: 3,
            borderRadius: 2,
            boxShadow: 1,
            maxWidth: 500,
            mt: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            If you need access to this resource, please reach out to your system administrator to request the
            appropriate permissions.
          </Typography>
        </Box>

        {/* Action Buttons */}
        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
          <Button variant="outlined" onClick={() => navigate(-1)} size="large">
            Go Back
          </Button>
          <Button variant="contained" startIcon={<HomeOutlined />} onClick={() => navigate('/')} size="large">
            Go to Dashboard
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default AccessDenied;
